import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Params, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { ConfigService } from '@shared/services';
import Keycloak from 'keycloak-js';
import {Config} from '@shared/models';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard  {

	private keycloak!: Keycloak;
	private cfg: Config;
	constructor(protected router: Router, protected keycloakAngular: KeycloakService, private configService: ConfigService) {
		super(router, keycloakAngular);
		this.cfg = configService.getConfig();
		if (this.cfg.keycloak.enabled) {
			this.keycloak = keycloakAngular.getKeycloakInstance();
		}
	}

	isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		return this.checkAccessAllowed(route.data, 'home');
	}

	canMatch(route: Route, segments: UrlSegment[]): Promise<boolean> {
		const path = this.getRedirectPath(segments);
		return this.checkAccessAllowed(route.data || {}, path);
	}

	private getRedirectPath(segments: UrlSegment[]): string {
		const path = segments.map((segment: UrlSegment) => {
			return segment.path;
		}).join('/');

		const queryParams = this.router.currentNavigation()?.extractedUrl.queryParams;

		if (queryParams) {
			return `${path}?${this.createQueryParamsString(queryParams)}`;
		}

		return path;
	}

	private createQueryParamsString(queryParams: Params): string {
		return Object.entries(queryParams).map((entry: [string, any]) => {
			return `${entry[0]}=${entry[1]}`;
		}).join('&');
	}

	checkAccessAllowed(data: Data, path: string): Promise<boolean> {
		// tslint:disable-next-line:typedef
		if (!this.cfg.keycloak.enabled) {
			return Promise.resolve(true);
		}

		return new Promise(async (resolve, reject) => {
			// Erst erneuern, dann urteilen: das Access-Token lebt standardmäßig nur
			// 5 Minuten. Ohne Refresh landet man mitten in der Sitzung wieder auf
			// der Anmeldemaske, obwohl die Session noch gültig ist.
			await this.keycloakAngular.updateToken(30).catch(() => false);

			const authenticated = await this.keycloakAngular.isLoggedIn();
			const userRoles = this.keycloakAngular.getUserRoles(true);
			if (!authenticated || authenticated && this.keycloak.isTokenExpired()) {
				return this.keycloak.login({
					// leerer returnUrl = aktueller Origin — funktioniert unter jedem
					// Hostnamen (localhost, Tunnel, Domain) ohne Config-Anpassung
					redirectUri: (this.configService.getConfig().keycloak.returnUrl || window.location.origin + '/') + path
				});
			}
			let requiredRoles = data.roles as string[];

			if (!requiredRoles) {
				requiredRoles = [];
			}
			if (!requiredRoles || requiredRoles.length === 0) {
				return resolve(true);
			} else {
				let granted = false;
				for (const requiredRole of requiredRoles) {
					if (userRoles.indexOf(requiredRole) > -1) {
						granted = true;
						break;

					}
				}
				if (!granted) {
					this.router.navigateByUrl('/no-permission');
					return resolve(false);
				}

				return resolve(granted);
			}
		});
	}

}
